"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = FooterItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactDeviceDetect = require("react-device-detect");
var _gatsby = require("gatsby");
var _utils = require("../../utils/utils");
// Packages

// Components

// Utils

// Styles
const {
  above
} = (0, _utils.getMediaQueries)();
const Item = _styledComponents.default.li.withConfig({
  displayName: "item__Item",
  componentId: "sc-1mn5mzt-0"
})(["&.legal{a{font-size:12px;line-height:16px;", "}*:not(a){font-size:16px;line-height:20px;}}&.list-item{list-style:none;padding-left:0;::before{height:0;width:0;}}"], above.mobile`
        font-size: 16px;
        line-height: 20px;
      `);
const Content = _styledComponents.default.a.withConfig({
  displayName: "item__Content",
  componentId: "sc-1mn5mzt-1"
})(["color:", ";font-size:14px;line-height:16px;text-decoration:none;*{color:", ";}", " :not(p):hover{color:", ";*{color:", ";}text-decoration:underline;}"], props => props.$defaultColor, props => props.$defaultColor, above.mobile`
    font-size: 16px;
    line-height: 24px;
  `, props => props.$activeColor, props => props.$activeColor);

// Main Component
function FooterItem({
  type,
  itemText,
  activeColor,
  defaultColor,
  linkAttributes,
  buttonFunctions,
  itemElement,
  legalItem
}) {
  let linkProps = {
    ...linkAttributes
  };
  if (Object.values(linkProps).length === 0) linkProps = null;
  if (type === "call") {
    if (linkProps.href) {
      linkProps.href = `tel:${linkProps.href}`;
    } else if (linkProps.to) {
      linkProps.to = `tel:${linkProps.to}`;
    }
  } else if (type === "directions") {
    if (linkProps.href) {
      linkProps.href = encodeURI(`${_reactDeviceDetect.isIOS ? `https://maps.apple.com/?address=` : `https://google.com/maps/place/`}${linkProps.href}`);
    } else if (linkProps.to) {
      linkProps.to = encodeURI(`${_reactDeviceDetect.isIOS ? `https://maps.apple.com/?address=` : `https://google.com/maps/place/`}${linkProps.to}`);
    }
  } else if (type === "email") {
    if (linkProps.href) {
      linkProps.href = `mailto:${linkProps.href}`;
    } else if (linkProps.to) {
      linkProps.to = `mailto:${linkProps.href}`;
    }
  } else if (type === "text") {
    if (linkProps.href) {
      linkProps.href = `sms:${linkProps.href}`;
    } else if (linkProps.to) {
      linkProps.to = `sms:${linkProps.href}`;
    }
  }
  return /*#__PURE__*/_react.default.createElement(Item, {
    className: `${itemElement === "li" ? "list-item" : ""} ${legalItem ? "legal" : ""} footer-item`,
    as: itemElement === "li" ? "li" : "div"
  }, /*#__PURE__*/_react.default.createElement(Content, Object.assign({}, linkProps, buttonFunctions, {
    $activeColor: activeColor,
    $defaultColor: defaultColor,
    as: linkProps ? linkProps.href ? "a" : _gatsby.Link : buttonFunctions ? "button" : "p"
  }), itemText));
}
FooterItem.propTypes = {
  /**
   * Text color of link when link is active (clicked / hovered / pressed)
   */
  activeColor: _propTypes.default.string,
  /**
   * Content text
   */
  itemText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
  /**
   * Default text color of link
   */
  defaultColor: _propTypes.default.string,
  /**
   * What html element should be used for footer item?
   */
  itemElement: _propTypes.default.oneOf(["div", "li"]),
  /**
   * Is this a legal item (e.g. Legal, Privacy Policy, Copyright)
   */
  legalItem: _propTypes.default.bool,
  /**
   * Type of link (if no type is specified will be a regular link)
   */
  type: _propTypes.default.oneOf(["call", "text", "email", "directions"]),
  /**
   * Content Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape(),
  /**
   * Button Functions, e.g. { onClick: () => {}}
   */
  buttonFunctions: _propTypes.default.shape()
};
FooterItem.defaultProps = {
  activeColor: _utils.colors["pacific-blue-2"].hex,
  defaultColor: _utils.colors["ice-grey-1"].hex,
  itemElement: "li"
};
FooterItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FooterItem",
  "props": {
    "activeColor": {
      "defaultValue": {
        "value": "colors[\"pacific-blue-2\"].hex",
        "computed": true
      },
      "description": "Text color of link when link is active (clicked / hovered / pressed)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "defaultColor": {
      "defaultValue": {
        "value": "colors[\"ice-grey-1\"].hex",
        "computed": true
      },
      "description": "Default text color of link",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "itemElement": {
      "defaultValue": {
        "value": "\"li\"",
        "computed": false
      },
      "description": "What html element should be used for footer item?",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"div\"",
          "computed": false
        }, {
          "value": "\"li\"",
          "computed": false
        }]
      },
      "required": false
    },
    "itemText": {
      "description": "Content text",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "element"
        }]
      },
      "required": true
    },
    "legalItem": {
      "description": "Is this a legal item (e.g. Legal, Privacy Policy, Copyright)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "description": "Type of link (if no type is specified will be a regular link)",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"call\"",
          "computed": false
        }, {
          "value": "\"text\"",
          "computed": false
        }, {
          "value": "\"email\"",
          "computed": false
        }, {
          "value": "\"directions\"",
          "computed": false
        }]
      },
      "required": false
    },
    "linkAttributes": {
      "description": "Content Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "buttonFunctions": {
      "description": "Button Functions, e.g. { onClick: () => {}}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    }
  }
};